import {
  VoiceDetectorConstructor,
  VoiceDetector,
  VoiceDetectorOptions,
} from "@service/voice-detection/voice-detector";
import { MicVAD } from "@ricky0123/vad-web";

const DEFAULT_REDEMPTION_FRAMES = 15;

export const AiVoiceDetector: VoiceDetectorConstructor = class AiVoiceDetector
  implements VoiceDetector
{
  private vad: MicVAD | null = null;

  constructor(options: VoiceDetectorOptions) {
    this.init(options);
  }

  async init({
    stream,
    callback,
    pauseDuration,
  }: VoiceDetectorOptions): Promise<void> {
    this.vad = await MicVAD.new({
      workletURL: "/public/vad/vad.worklet.bundle.min.js",
      modelURL: "/public/vad/silero_vad.onnx",
      ortConfig: (ort) => {
        ort.env.wasm.numThreads = 1;
        ort.env.wasm.wasmPaths = {
          "ort-wasm-simd.wasm": "/public/vad/ort-wasm-simd.wasm",
        };
      },
      stream,
      redemptionFrames: pauseDuration
        ? this.pauseDurationToRedemptionFrames(pauseDuration)
        : DEFAULT_REDEMPTION_FRAMES,
      onSpeechStart: () => {
        callback({ type: "start" });
      },
      onSpeechEnd: () => {
        callback({ type: "end" });
      },
    });

    this.vad.start();

    return;
  }

  destroy(): void {
    if (this.vad) {
      try {
        this.vad.destroy();
      } catch (e) {
        console.error(e);
      }
    }
  }

  private pauseDurationToRedemptionFrames(pauseDuration: number): number {
    return Math.ceil((pauseDuration * (16000 / 1536)) / 1000);
  }
};
